import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import React, { useState } from 'react';
import { Icon, getUtility } from '@livable/saas-react-components';
import { Button, Menu, Skeleton } from '@mui/material';
export const DetailedItem = _ref => {
  let name = _ref.name,
    subname = _ref.subname,
    caption = _ref.caption,
    icon = _ref.icon,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'utility' : _ref$type,
    _ref$disableAmenityEd = _ref.disableAmenityEdit,
    disableAmenityEdit = _ref$disableAmenityEd === void 0 ? true : _ref$disableAmenityEd,
    handleOpenAmenityModal = _ref.handleOpenAmenityModal,
    handleRemoveAmenityModal = _ref.handleRemoveAmenityModal,
    handleOpenUtilityModal = _ref.handleOpenUtilityModal,
    handleRemoveUtility = _ref.handleRemoveUtility,
    handleAutoBilling = _ref.handleAutoBilling,
    isDummyLoadingState = _ref.isDummyLoadingState;
  const classes = useStyles();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlock
  }, isDummyLoadingState ? /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlockIcon
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rectangular",
    animation: "wave",
    height: 32,
    width: 32
  })) : icon && /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlockIcon
  }, getUtility(icon).icon()), /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlockDetails
  }, isDummyLoadingState ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'break-all'
    }
  }, name, " ", subname && /*#__PURE__*/React.createElement("span", null, "(", subname, ")")), isDummyLoadingState ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })) : caption && caption !== 'Default' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: caption
    }
  })) : null), !isDummyLoadingState && /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlockControls
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    disabled: isDummyLoadingState,
    'custom-attribute': '586-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, type === 'utility' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      handleOpenUtilityModal();
    },
    'custom-attribute': '587-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), "Edit utility details"), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      handleRemoveUtility();
    },
    'custom-attribute': '588-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), "Remove utility")), type === 'amenity' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      handleRemoveAmenityModal();
    },
    'custom-attribute': '589-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), "Remove amenity")))));
};